import { useIntl, defineMessages } from 'react-intl'
import { formatCurrency } from '../../../../../../helpers/formatters'
import { Box, Flex, Text, Heading, Card } from '@homebotapp/hb-react-component-catalog'

export const MSG = defineMessages({
  hoaSpelledOut: {
    id: 'EstimatedMonthlyPaymentBreakdown.hoaSpelledOut',
    defaultMessage: "Homeowner's Association"
  },
  hoaAbbreviation: {
    id: 'EstimatedMonthlyPaymentBreakdown.hoaAbbreviation',
    defaultMessage: 'HOA'
  },
  hoaFees: {
    id: 'EstimatedMonthlyPaymentBreakdown.hoaFees',
    defaultMessage: '{hoa} fees'
  },
  hoaFeesDescription: {
    id: 'EstimatedMonthlyPaymentBreakdown.hoaFeesDescription',
    defaultMessage: 'Based on listing information'
  }
})

export interface EstimatedMonthlyPaymentBreakdownHoaFeesProps {
  hoaFees: number
}

export const EstimatedMonthlyPaymentBreakdownHoaFees = ({ hoaFees }: EstimatedMonthlyPaymentBreakdownHoaFeesProps) => {
  const intl = useIntl()

  return (
    <Card p={3}>
      <Flex justify='space-between' align='center'>
        <Flex gap={2} align='center'>
          <Box bg='primary.900' width={3} height={3} borderRadius='50%' />

          <Heading as='h4' size={['2xs', 'xs', 'sm']}>
            {intl.formatMessage(MSG.hoaFees, {
              hoa: (
                <span>
                  <Text as='span' fontWeight='inherit' size='inherit' fontStyle='inherit' display={['initial', 'none']}>
                    <abbr title={intl.formatMessage(MSG.hoaSpelledOut)} style={{ textDecoration: 'none' }}>
                      {intl.formatMessage(MSG.hoaSpelledOut)}
                    </abbr>
                  </Text>
                  <Text as='span' fontWeight='inherit' size='inherit' fontStyle='inherit' display={['none', 'initial']}>
                    <span>
                      {intl.formatMessage(MSG.hoaSpelledOut)}{' '}
                      <Text
                        as='span'
                        fontWeight='inherit'
                        size='inherit'
                        fontStyle='inherit'
                        display={['none', 'none', 'initial']}
                      >
                        ({intl.formatMessage(MSG.hoaAbbreviation)})
                      </Text>
                    </span>
                  </Text>
                </span>
              )
            })}
          </Heading>
        </Flex>
        <Text
          mb={0}
          color='neutral.900'
          size={['xs', 'sm', 'md']}
          fontWeight='semibold'
          style={{ fontVariant: 'tabular-nums' }}
        >
          {formatCurrency(hoaFees)}
        </Text>
      </Flex>
      <Text ml={5} as='span' size={['2xs', 'xs', 'sm']} display='block'>
        {intl.formatMessage(MSG.hoaFeesDescription)}
      </Text>
    </Card>
  )
}
